import { LookupModel } from '../../../../api/models';

export enum TranscriptionProvider {
  Telego = 'telego',
  Deepgram = 'deepgram',
}

export const TRANSCRIPTION_PROVIDERS: LookupModel[] = [
  { text: 'Telego', id: TranscriptionProvider.Telego },
  { text: 'Deepgram', id: TranscriptionProvider.Deepgram },
];

export const LANGUAGE_CODES_DEEPGRAM: LookupModel[] = [
  { text: 'Automatic Language Detection', id: 'auto' },
  { text: 'Multilingual (Spanish + English)', id: 'multi' },
  { text: 'Bulgarian', id: 'bg' },
  { text: 'Catalan', id: 'ca' },
  { text: 'Chinese (Mandarin, Simplified)', id: 'zh-CN' },
  { text: 'Chinese (Mandarin, Traditional)', id: 'zh-TW' },
  { text: 'Chinese (Cantonese, Traditional)', id: 'zh-HK' },
  { text: 'Czech', id: 'cs' },
  { text: 'Danish', id: 'da' },
  { text: 'Dutch', id: 'nl' },
  { text: 'English', id: 'en' },
  { text: 'English (US)', id: 'en-US' },
  { text: 'English (Australia)', id: 'en-AU' },
  { text: 'English (Britain)', id: 'en-GB' },
  { text: 'English (New Zealand)', id: 'en-NZ' },
  { text: 'English (India)', id: 'en-IN' },
  { text: 'Estonian', id: 'et' },
  { text: 'Finnish', id: 'fi' },
  { text: 'Flemish', id: 'nl-BE' },
  { text: 'French', id: 'fr' },
  { text: 'French (Canada)', id: 'fr-CA' },
  { text: 'German', id: 'de' },
  { text: 'German (Switzerland)', id: 'de-CH' },
  { text: 'Greek', id: 'el' },
  { text: 'Hindi', id: 'hi' },
  { text: 'Hungarian', id: 'hu' },
  { text: 'Indonesian', id: 'id' },
  { text: 'Italian', id: 'it' },
  { text: 'Japanese', id: 'ja' },
  { text: 'Korean (South Korea)', id: 'ko-KR' },
  { text: 'Latvian', id: 'lv' },
  { text: 'Lithuanian', id: 'lt' },
  { text: 'Malay', id: 'ms' },
  { text: 'Norwegian', id: 'no' },
  { text: 'Polish', id: 'pl' },
  { text: 'Portuguese (Brazil)', id: 'pt-BR' },
  { text: 'Portuguese (Portugal)', id: 'pt-PT' },
  { text: 'Romanian', id: 'ro' },
  { text: 'Russian', id: 'ru' },
  { text: 'Slovak', id: 'sk' },
  { text: 'Spanish', id: 'es' },
  { text: 'Spanish (Latin America)', id: 'es-419' },
  { text: 'Swedish', id: 'sv-SE' },
  { text: 'Thai', id: 'th-TH' },
  { text: 'Turkish', id: 'tr' },
  { text: 'Ukrainian', id: 'uk' },
  { text: 'Vietnamese', id: 'vi' },
];

export const LLM_MODELS_DEEPGRAM: LookupModel[] = [
  { text: 'Nova 3', id: 'nova-3' },
  { text: 'Nova 3 (general)', id: 'nova-3-general' },
  { text: 'Nova 3 (medical)', id: 'nova-3-medical' },
  { text: 'Nova 2', id: 'nova-2' },
  { text: 'Nova 2 (general)', id: 'nova-2-general' },
  { text: 'Nova 2 (meeting)', id: 'nova-2-meeting' },
  { text: 'Nova 2 (phone call)', id: 'nova-2-phonecall' },
  { text: 'Nova 2 (voicemail)', id: 'nova-2-voicemail' },
  { text: 'Nova 2 (finance)', id: 'nova-2-finance' },
  { text: 'Nova 2 (medical)', id: 'nova-2-medical' },
  { text: 'Nova', id: 'nova' },
  { text: 'Nova (general)', id: 'nova-general' },
  { text: 'Nova (phone call)', id: 'nova-phonecall' },
  { text: 'Enhanced', id: 'enhanced' },
  { text: 'Enhanced (general)', id: 'enhanced-general' },
  { text: 'Enhanced (phone call)', id: 'enhanced-phonecall' },
  { text: 'Enhanced (meeting)', id: 'enhanced-meeting' },
  { text: 'Enhanced (finance)', id: 'enhanced-finance' },
  { text: 'Whisper', id: 'whisper' },
  { text: 'Whisper (tiny)', id: 'whisper-tiny' },
  { text: 'Whisper (small)', id: 'whisper-small' },
  { text: 'Whisper (medium)', id: 'whisper-medium' },
  { text: 'Whisper (large)', id: 'whisper-large' },
];

export const LLM_MODELS_TELEGO: LookupModel[] = [
  // { text: 'Whisper', id: 'whisper' },
  // { text: 'Whisper (tiny)', id: 'whisper-tiny' },
  // { text: 'Whisper (small)', id: 'whisper-small' },
  // { text: 'Whisper (medium)', id: 'whisper-medium' },
  { text: 'Whisper (large)', id: 'whisper-large' },
];
